webpackJsonp([70144966829960],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Submit = __webpack_require__(81);
	
	var _Submit2 = _interopRequireDefault(_Submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function gtag_report_conversion(url) {
	    var callback = function callback() {
	        if (typeof url != 'undefined') {
	            window.location = url;
	        }
	    };
	    typeof window !== "undefined" && window.gtag('event', 'conversion', {
	        'send_to': 'AW-803806917/c1tXCJi3ppABEMW9pP8C',
	        'event_callback': callback
	    });
	
	    return false;
	}
	
	var Form = function (_Component) {
	    _inherits(Form, _Component);
	
	    function Form(props) {
	        _classCallCheck(this, Form);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {};
	
	        _this.handleFormChange = _this.handleFormChange.bind(_this);
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	        return _this;
	    }
	
	    Form.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            title = _props.title,
	            description = _props.description,
	            submit = _props.submit,
	            children = _props.children;
	
	
	        var mapChildrenWithProps = function mapChildrenWithProps(children) {
	            return _react.Children.map(children, cloneChildWithProps.bind(_this2));
	        };
	        var cloneChildWithProps = function cloneChildWithProps(child) {
	            return _react2.default.cloneElement(child, {
	                onChange: _this2.handleFormChange,
	                value: _this2.state[child.props.name]
	            });
	        };
	
	        return _react2.default.createElement(
	            'form',
	            { action: '#', className: 'form', onSubmit: this.handleFormSubmit, id: 'form' },
	            title ? _react2.default.createElement(
	                'h2',
	                null,
	                title
	            ) : null,
	            description ? _react2.default.createElement('p', { dangerouslySetInnerHTML: description }) : null,
	            mapChildrenWithProps(children),
	            _react2.default.createElement(_Submit2.default, { text: submit })
	        );
	    };
	
	    Form.prototype.handleFormChange = function handleFormChange(event) {
	        var _setState;
	
	        var target = event.target;
	        var value = target.value;
	        var name = target.name;
	
	        this.setState((_setState = {}, _setState[name] = value, _setState));
	    };
	
	    Form.prototype.handleFormSubmit = function handleFormSubmit(event) {
	        var _this3 = this;
	
	        event.preventDefault();
	
	        document.getElementById('form').innerHTML = '<h2 id="form">Sending Message</h2>';
	
	        if (typeof window !== 'undefined') {
	            // let subject = `${this.state.name} needs your assistance!`
	            var subject = this.state.name + ' from ' + this.state.company + ' - LocusLabs.com contact form request';
	            var body = '\nThis contact form was submitted at ' + Date().toString() + '.\n\nReferring URL: ' + window.location.href + '\n\nIP address: ' + window.ip + '\n';
	
	            Object.keys(this.state).map(function (key) {
	                body += '\n' + key + ': ' + _this3.state[key];
	            });
	
	            var data = {
	                destination: {
	                    to: ['info']
	                },
	                message: {
	                    subject: subject,
	                    body: body
	                },
	                replyTo: ["info"],
	                source: "info"
	            };
	
	            window.fetch('https://obw4r044f2.execute-api.us-west-2.amazonaws.com/prod/v1/email', {
	                method: 'POST',
	                body: JSON.stringify(data),
	                headers: {
	                    'Accept': 'application/json, text/plain, */*',
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                console.log('Email Sent:', data);
	                document.getElementById('form').innerHTML = '<h2 id="form">Message Sent</h2>';
	                window.dataLayer = window.dataLayer || [];
	                gtag_report_conversion();
	            });
	        }
	    };
	
	    return Form;
	}(_react.Component);
	
	Form.propTypes = {
	    title: _propTypes2.default.string,
	    description: _propTypes2.default.node,
	    submit: _propTypes2.default.string
	};
	exports.default = Form;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Submit = function Submit(_ref) {
	    var text = _ref.text;
	    return _react2.default.createElement(
	        "button",
	        { type: "submit", id: "formSubmit", className: "btn btn-primary" },
	        text
	    );
	};
	
	exports.default = Submit;
	module.exports = exports["default"];

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextAreaInput = function TextAreaInput(_ref) {
	    var placeholder = _ref.placeholder,
	        name = _ref.name,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        required = _ref.required;
	    return _react2.default.createElement(
	        "div",
	        { className: "form-group" },
	        _react2.default.createElement("textarea", { placeholder: placeholder, name: name, value: value, onChange: onChange, required: required })
	    );
	};
	
	exports.default = TextAreaInput;
	module.exports = exports["default"];

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextInput = function TextInput(_ref) {
	    var type = _ref.type,
	        placeholder = _ref.placeholder,
	        name = _ref.name,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        label = _ref.label,
	        required = _ref.required;
	    return _react2.default.createElement(
	        "div",
	        { className: "form-group" },
	        _react2.default.createElement("input", {
	            type: type,
	            placeholder: placeholder,
	            name: name,
	            value: value,
	            onChange: onChange,
	            required: required
	        }),
	        label ? _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement(
	                "small",
	                null,
	                label
	            )
	        ) : null
	    );
	};
	
	exports.default = TextInput;
	module.exports = exports["default"];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/map.0050cd91.jpg";

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(80);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _TextAreaInput = __webpack_require__(82);
	
	var _TextAreaInput2 = _interopRequireDefault(_TextAreaInput);
	
	var _TextInput = __webpack_require__(83);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _map = __webpack_require__(566);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _mark = __webpack_require__(568);
	
	var _mark2 = _interopRequireDefault(_mark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contactPage = function (_Component) {
	  _inherits(contactPage, _Component);
	
	  function contactPage() {
	    _classCallCheck(this, contactPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  contactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "main",
	      { id: "main", role: "main", style: { marginTop: '134px', overflow: 'visible' } },
	      _react2.default.createElement(_reactHelmet2.default, { title: "LocusLabs - Contact Us" }),
	      _react2.default.createElement(
	        "section",
	        { className: "contact-section viewport-section" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "form-area" },
	            _react2.default.createElement(
	              _Form2.default,
	              { title: "Contact Us", description: { __html: 'For technical support and content management queries, please access the links at the bottom of this page. For pricing, or to schedule a demo of our products please use <a href="/#contact">this form</a><br/><br/>For all other inquiries, please fill out the form below and we will be touch shortly:<br/>' }, submit: "SEND MESSAGE" },
	              _react2.default.createElement(_TextInput2.default, { type: "text", placeholder: "Name...", name: "name", required: true }),
	              _react2.default.createElement(_TextInput2.default, { type: "text", placeholder: "Company...", name: "company", required: true }),
	              _react2.default.createElement(_TextInput2.default, { type: "email", placeholder: "Email...", name: "email", required: true }),
	              _react2.default.createElement(_TextInput2.default, { type: "text", placeholder: "How did you hear about us...", name: "referral", required: true }),
	              _react2.default.createElement(_TextAreaInput2.default, { placeholder: "How can we help you...", name: "details", required: true })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "map-wrap" },
	            _react2.default.createElement("img", { src: _map2.default, alt: "", width: "514", height: "514" }),
	            _react2.default.createElement(
	              "div",
	              { className: "mark" },
	              _react2.default.createElement("img", {
	                src: _mark2.default,
	                alt: "",
	                width: "60",
	                height: "59"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pop-up" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "LocusLabs, Inc. ",
	                _react2.default.createElement("br", null),
	                "331 Jefferson Street ",
	                _react2.default.createElement("br", null),
	                "Oakland, CA 94607 ",
	                _react2.default.createElement("br", null),
	                "USA"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return contactPage;
	}(_react.Component);
	
	exports.default = contactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-3d1c7c310acbad94a9b1.js